import {ApiSlice} from "@/store/ApiSlice";
import RESTAPIConfig from "@/config/RESTAPIConfig";
import {GetHintByAliasInterface} from "@/api/ReferenceBooks/Hints/HintsInterface";

const restApiConfig = new RESTAPIConfig();

export const GetHintByAliasApiSlice = ApiSlice.injectEndpoints({
    endpoints: builder => ({
        getHintByAlias: builder.query<GetHintByAliasInterface, string>({
            query: (alias: string) => ({
                url: restApiConfig.baseUrl + restApiConfig.apiPrefixV2 + restApiConfig.hintByAlias(alias),
                params: {
                    alias,
                },
            }),
            providesTags: ["FetchedData", "HintsByAlias"],
            keepUnusedDataFor: 21600,
        })
    })
});

export const {useGetHintByAliasQuery} = GetHintByAliasApiSlice;
